import CloseIcon from "@mui/icons-material/Close";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import GlobalButton from "../CustomButton";
import { t } from "i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const DeleteAlert = forwardRef(({ handleDelete }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle
        variant="h1"
        fontWeight={600}
        fontSize={"1.5rem"}
        fontFamily={"inter"}
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
      >
        {paramsData?.heading || t("confirmation")}
      </DialogTitle>
      <DialogContent dividers>
        <Stack alignItems={"center"} justifyContent={"center"}>
          <ReportGmailerrorredIcon
            htmlColor={"red"}
            sx={{
              fontSize: "5rem",
            }}
          />
        </Stack>
        <Typography variant={"body1"} mt={2.5} textAlign={"center"}>
          {paramsData?.warningText}
        </Typography>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"custom_outlined"}
          btnText={"close"}
          handleClickBtn={handleClose}
          styleProps={{
            height: 38,
            width: 100,
            borderRadius: "6px",
          }}
        />
        <GlobalButton
          btnText={paramsData?.buttonText || "delete"}
          handleClickBtn={() => handleDelete(paramsData)}
          styleProps={{
            height: 38,
            width: 100,
            backgroundColor: "red",
            borderColor: "red",
            borderRadius: "6px",
          }}
          hoverProperties={{
            backgroundColor: "red",
            borderColor: "red",
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default DeleteAlert;
